import { Card, Empty, Typography } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useGetIdentity } from "@refinedev/core";
import { useTranslation } from "react-i18next";
import type { UserInfo } from "../../types/auth";
import { PageHeader } from "../../components/common/PageHeader";

const { Paragraph } = Typography;

/**
 * Auditor section home — placeholder until charts/stats land.
 * Shows a different copy depending on whether the user is an Auditor Manager
 * (user_type 4) or a regular Auditor (user_type 5).
 */
export const AuditorHome = () => {
  const { data: identity } = useGetIdentity<UserInfo>();
  const { t } = useTranslation();
  const isManager = identity?.app_user?.user_type === 4;

  return (
    <Card>
      <PageHeader
        icon={<HomeOutlined />}
        title={t("auditor_section.home.title")}
        subtitle={t("auditor_section.home.subtitle")}
      />
      <Paragraph type="secondary">
        {isManager
          ? t("auditor_section.home.manager_coming_soon")
          : t("auditor_section.home.coming_soon")}
      </Paragraph>
      <Empty description={false} />
    </Card>
  );
};

export default AuditorHome;
